import clsx from 'clsx';
import { ICONS, type IconName } from './registry.js';

export interface IconProps {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  className?: string;
  label?: string;
  spin?: boolean;
}

export function Icon({
  name,
  size = 20,
  strokeWidth = 1.75,
  className,
  label,
  spin = false,
}: IconProps) {
  const Glyph = ICONS[name];
  const glyph = (
    <Glyph
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={clsx('tb-icon', spin && 'tb-icon--spin', !label && className)}
      aria-hidden={true}
    />
  );

  if (!label) return glyph;

  return (
    <span role="img" aria-label={label} className={clsx('tb-icon-wrap', className)}>
      {glyph}
    </span>
  );
}
